import React from "react";
const DescriptionList = ({ description = "",className }) => {

  // Decode escaped HTML
  const formattedDescription = description
    ?.replace(/\\u003c/g, "<")
    ?.replace(/\\u003e/g, ">");

  // Split by newline into bullet points
  const descriptionPoints = formattedDescription
    ?.split("\n")
    ?.filter((line) => line.trim() !== "");

  return (

    <ul className={`custom-list-container ${className || ''}`} style={{  listStyleType: "none", margin: 0 }}>

      {descriptionPoints?.map((point, i) => {
        const hasBold = /<b>/i.test(point); // Check if <b> tag exists
        return (
          <li
            className={`custom-list-item ${hasBold ? 'custom-list-item-bold' : ''}`}
            key={i}
            style={
              hasBold
                ? { listStyleType: "none", paddingLeft: "0", fontWeight: "bold" }
                : {}
            }
            dangerouslySetInnerHTML={{ __html: point }}
          />
        );
      })}
    </ul>
  );
};

export default DescriptionList;
